import React, { useMemo } from 'react';
import InsightCard from './InsightCard';
import groupByDate from '../utils/groupByDate';

export default function FeedGroupedList({ items, marketData, onOpen, watchlistSymbols, portfolioSymbols }) {
    const groups = useMemo(() => groupByDate(items), [items]);
    if (!groups.length) return null;
    return (
        <div className="flex flex-col gap-[24px]">
            {groups.map((g) => (
                <section key={g.key}>
                    <h4 className="text-[11px] font-bold tracking-[0.08em] text-[#9CA3AF] m-0 mb-[12px]">
                        {g.heading}
                    </h4>
                    <div className="flex flex-col gap-[12px]">
                        {g.items.map((item) => (
                            <InsightCard
                                key={item.id}
                                item={item}
                                market={marketData?.[String(item.symbol || '').toUpperCase()]}
                                onOpen={onOpen}
                                inWatchlist={watchlistSymbols?.has(String(item.symbol || '').toUpperCase())}
                                inPortfolio={portfolioSymbols?.has(String(item.symbol || '').toUpperCase())}
                            />
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
}
